import classNames from "classnames";
import ActivityActions from "PFApp/components/activity_actions/activity_actions";
import { HeaderTimeAgo } from "PFApp/components/card_tx/header/header_time_ago";
import { Activity } from "PFTypes";
import { useTranslation } from "react-i18next";

import { ActivityType, ActivityTypeBadge } from "./activity_type_badge";
import css from "./header.module.scss";

export type HeaderProps = {
  type: ActivityType;
  task: Activity;
  isFeed?: boolean;
  onShare?: (id: number) => void;
  handleCloseActivitySuccess?: () => void;
};

export const Header = ({ type, task, onShare, handleCloseActivitySuccess }: HeaderProps) => {
  const { t } = useTranslation("core");

  return (
    <div className={css.wrapper}>
      <div className={classNames(css.section, css.sectionBadge)}>
        <ActivityTypeBadge type={type} />
      </div>
      <div className={css.section}>
        <HeaderTimeAgo time={task.created_at} />
        <ActivityActions
          task={task}
          handleCloseActivitySuccess={handleCloseActivitySuccess}
          additionalOptions={
            onShare && [
              {
                id: "share",
                displayElement: t("activityActions.share"),
                item: () => onShare(task.id)
              }
            ]
          }
        />
      </div>
    </div>
  );
};
